import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
  requiredRole?: 'super_admin' | 'admin';
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ 
  children, 
  requiredRole = 'super_admin' 
}) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role !== requiredRole && user.role !== 'super_admin') {
    return <Navigate to="/workers" />;
  }

  return <>{children}</>;
};
